<div class="aig-textgroup">
  <h1 class="u-h1 u-color-primary1 u-mb-4">
    Contrata tu póliza de seguro
  </h1>
  <p>
    Cualquiera puede ser víctima de un ciberataque indiscriminado. Miles de personas sufren cada día el robo de sus datos u otras formas de extorsión en Internet.
    <br>
    Consecuencias como el robo de dinero, la suplantación de la identidad, el bloqueo de nuestros ordenadores, pueden ser evitadas o paliadas.
  </p>
  <p class="u-mt-4">
    Haz clic <a class="u-color-primary3" href="../../../../../assets/docs/Flyer Marsh.pdf" target="_blank"> aquí </a> para conocer más información sobre este producto.
  </p>
</div>
